import React from 'react'
import { createUseStyles, useTheme } from 'react-jss'

import View from '../form/View'
import Footer from '../form/Footer'

const useStyles = createUseStyles(theme => ({
  root: {
    height: '100%',
    flexDirection: 'column',
    flex: 1
  },
  content: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '0 36px'
  },
  title: {
    fontFamily: 'Fira Sans, sans serif',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '42px',
    color: theme.colors.primary,
    marginBottom: '15px'
  },
  subtitle: {
    fontFamily: 'Fira Sans, sans serif',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '18px',
    color: theme.colors.secondary,
    marginBottom: '15px'
  },
}))

function ReserveError (props) {
  const theme = useTheme()
  const styles = useStyles({ ...props, theme })
  const { statusCode, message, next } = props

  /*useEffect(() => {
    const timer = setTimeout(() => next(), timeout)
    return () => clearTimeout(timer)
  }, [ timeout ])*/

  return (
    <View className={styles.root}>
      <View className={styles.content}>
        { statusCode === 401 ? (
            <View className={styles.title}>
              { message }
            </View>
          ) : (
            <>
              <View className={styles.title}>Ocorreu um erro inesperado! =(</View>
              <View className={styles.subtitle}>Entre em contato com o administrador do sistema ou tente novamente.</View>
            </>
        )}
      </View>
      <Footer 
        onNext={next}
        nextLabel={'Tentar novamente'}
      />
    </View>
  )
  
}

export default ReserveError